import { CalculateRes } from '@/containers/Freight/types'
import API from '@/services/http'

export interface CalFreightParamsTypes {
  senderAddressName: {
    countryCode: string
    provinceName: string
    cityName: string
    districtName: string
    townName?: string
    zipCode: string
  }
  consigneeAddressName: {
    countryCode: string
    provinceName: string
    cityName: string
    districtName: string
    townName?: string
    zipCode: string
  }
  weight: string
  weightUnit: 'kg' | 'g' | 'lb' | 'oz'
  currencyCode: string
  lastExpressTypeCode?: string
  pageSize?: number
  length: string
  width: string
  height: string
  lengthUnit: 'cm'
}

/**
 * 运费试算
 * @param params
 * @returns
 */
export const feeTryCalculate = async (params: CalFreightParamsTypes) => {
  const res = await API.admin.post<CalculateRes>('/api/fee/try/calculate', params)
  res?.data?.calculateResultVos?.forEach((item) => {
    try {
      item.channelCustomParamParse = JSON.parse(item.channelCustomParam)
    } catch (error) {}
  })
  return res
}
